import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../HomePage/Navbar";
import Footer from "../HomePage/Footer";
import Courses, { COURSES_DATA } from "./Courses";

function CoursesIndex() {
  // 1. SCROLL TO TOP ON MOUNT
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);

  // 2. JSON-LD STRUCTURED DATA FOR COURSES
  const courseSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Courses Offered at AnaBel Institute",
    "description":
      "Government approved Nursery Teacher Training (NTT), Montessori, Distance Education Degrees (BA, B.Com, BCA, MA, MBA), Open Schooling & Computer courses in Hassan, Karnataka.",
    "itemListElement": COURSES_DATA.map((course, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "Course",
        "name": course.title,
        "description": course.desc,
        "provider": {
          "@type": "EducationalOrganization",
          "name": "AnaBel Institute",
          "sameAs": "https://www.anabel.in"
        }
      }
    }))
  };

  return (
    <main style={{ fontFamily: "'Poppins', sans-serif" }}>
      {/* SEO Tags */}
      <Helmet>
        <title>Courses | AnaBel Institute - NTT, Montessori, Distance Education & Skills</title>
        <meta
          name="description"
          content="Explore Govt. approved NTT (Nursery Teacher Training), Montessori, Distance Education Degrees (BA, B.Com, BCA, MA, M.Com, MBA), 10th/12th Open Schooling, and Tally computer courses in Hassan, Karnataka."
        />
        <meta property="og:title" content="Courses | AnaBel Institute Hassan" />
        <meta
          property="og:description"
          content="Explore Govt. approved teacher training, distance degrees, and career certifications at AnaBel Institute. 19+ years of experience."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.anabel.in/courses" />
        <script type="application/ld+json">
          {JSON.stringify(courseSchema)}
        </script>
      </Helmet>

      {/* Header Navigation */}
      <Navbar />

      {/* Courses Main View */}
      <Courses />

      {/* Footer */}
      <Footer />
    </main>
  );
}

export default CoursesIndex;
